/**
 * Renders products based on the [data-url] attribute of the <section> element.
 * 
 * The default behavior for the element should be to remain hidden while we are searching for
 * products. Once we have the products we can start the rendering of the element again.
 * 
 * ## Implementation
 * 
 * This script starts by calling the url we need to render the script using the script rendering library.
 * The results can be used to re-render the section once.
 */

import {renderSection} from '@nx-paeonia/utils-http'

document.querySelectorAll<HTMLElement>('.product-recommendations-section').forEach(
    section => {
        const url = section.dataset.url;
        if (!url) return

        renderSection(url, section.parentElement ?? section)
    }
)